<template>
  <div id="page-user-list">

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <div class="flex-grow">
          </div>
        </div>
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ page * per_page - (per_page - 1) }} - {{ row_total - page * per_page > 0 ? page * per_page : row_total }} of {{ row_total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="keyword" @keyup="search" placeholder="Search..." />
      </div>

      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>IMEI</th>
              <th>Device Name</th>
              <th>Service</th>
              <th>Last Service</th>
              <th>Last Odometer</th>
              <th>Current Odometer</th>
              <th>Due Date</th>
              <th>Next Odometer</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="10" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for='(item, index) in data' :key='index'>
              <td>{{ ((page-1)*per_page) + (index+1) }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.gps_data ? item.gps_data.device_name : '' }}</td>
              <td>{{ item.service ? item.service.name : '' }}</td>
              <td>{{ item.last_time }}</td>
              <td>{{ item.last_odo }} Km</td>
              <td>{{ (parseFloat(item.last_odo) + parseFloat(item.counter)).toFixed(2).replace(/\.00$/, "") }} Km</td>
              <!-- <td>{{ date_now() }}</td> -->
              <td>{{ date_now() > item.next_time ? date_diff_indays(item.next_time, date_now())+ ' days ago': date_diff_indays(item.last_time, item.next_time)+ ' days later'}}</td>
              <td>{{ item.next_odo }} Km</td>
              <td style="width: 90px">
                <div class="flex">
                  <vx-tooltip text="Assign Due Date Service" position="top">
                    <vs-button :id="`assignBtn${item.id}`" type="border" size="small" icon-pack="feather" icon="icon-pocket" color="primary" class="mr-2 vs-con-loading__container" @click="assign(item.id)"></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>


        <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
          <template>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-2/2 w-full">
                <label class="text-sm opacity-75">Service</label>
                <v-select :disabled="action == 'edit'" :options="serviceList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="input.service" class="mb-2 md:mb-0" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-2/2 w-full">
                <label class="text-sm opacity-75">Device</label>
                <v-select :disabled="action == 'edit'" :options="deviceList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="input.imei" @search="searchDevice" class="mb-2 md:mb-0" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Last Odometer (Km)</label>
                  <vs-input disabled type="number" class="w-full" v-model="input.last_odo"/>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Last Service</label>
                <template>
                  <flat-pickr disabled class="w-full" v-model="input.last_time" />
                </template>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Next Odometer (Km)</label>
                  <vs-input disabled type="text" class="w-full" v-model="input.next_odo"/>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Next Service</label>
                <template>
                  <flat-pickr disabled class="w-full" v-model="input.next_time" />
                </template>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Odometer (Km)</label>
                  <vs-input type="number" class="w-full" v-model="input.odo"/>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">Service Date</label>
                <template>
                  <flat-pickr class="w-full" v-model="input.date" />
                </template>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full ml-auto">
                <vs-button :disabled="loading" id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
                <vs-button v-show="action === 'add'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
              </div>
            </div>

          </template>
        </vs-popup>

      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'MaximumParking',
  components: {
    vSelect, flatPickr
  },
  data () {
    return {
      data: [],
      actor: '',
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',

      loading: false,
      tempId: 0,

      input: {
        service: '',
        imei: '',
        last_time: '',
        last_odo: '',
        next_odo: '',
        next_time: '',
        due_date: '',
        current_odo: '',
        odo: '',
        date: ''
      },

      deviceList: [],
      serviceList: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error',
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total/this.per_page)
    },

    userdata() {
      return this.$store.state.AppActiveUser
    },
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if(this.page != 1) this.page = 1
      else this.initTable()
    },

  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''

    this.initTable()
    this.selectService()

  },

  mounted () {
  },

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800);
    },

    date_now() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + '-' +  mm + '-' + dd;
      return today;
    },

    date_diff_indays(date1, date2) {
      var dt1 = new Date(date1);
      var dt2 = new Date(date2);
      var now = this.date_now()

      let result = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));

      if(date2 < now){
        var dt3 = new Date(date2)
        var dt4 = new Date(now)

        let day_plus = this.date_diff_indays(dt3, dt4)

        return day_plus;
      }

      return result;
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map(item => {
        this.input[item] = ''
      })
    },

    selectService() {
      this.$http.get(`${this.$api.endpoint}/service/select`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.serviceList = res.data.message.data
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    searchDevice(keyword) {
      if(keyword.length >= 3) {
        this.$http.get(`${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        }).then(res => {
          this.deviceList = res.data.message.data
        }).catch(error => {
          this.$gf.httpErrorHandler(error)
        })
      }else{
        this.deviceList = []
      }
    },

    initTable() {
      this.loading = true
      this.$http.get(`${this.$api.endpoint}/service_assignment/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.row_total = res.data.message.total
        this.data = res.data.message.data
        this.loading = false
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    assign(id) {
      this.tempId = id
      this.action = 'edit'
      this.popupTitle = 'Assign Due Date Service'

      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#assignBtn" + id,
        scale: 0.45
      })

      this.$http.get(`${this.$api.endpoint}/service_assignment/detail/${id}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close(`#assignBtn${id} > .con-vs-loading`)

        const data = res.data.message.data

        this.input.imei = {
          value: data.imei,
          label: `${data.gps_data.device_name} (device name)`
        }

        this.input.service = this.serviceList.find(item => {
          return item.value === data.service_id
        })

        this.input.last_time = data.last_time
        this.input.last_odo = data.last_odo
        this.input.next_odo = data.next_odo
        this.input.next_time = data.next_time
        this.input.odo = parseInt(data.last_odo) + parseInt(data.counter)
        this.input.date = this.date_now()

        this.showPopup = true
      })
    },

    submit() {
      this.loading = true
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/service_assignment/action/${this.tempId}`
      // console.log(this.input.imei)
      this.$http.post(url, this.input,
      {
        headers:{
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")

        this.notify = res.data.message.split('_').join(' ')

        this.loading = false
        this.showPopup = false
        this.initTable()
        this.reset()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.loading = false
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.$gf.httpErrorHandler(error)
      })
    },

  }
}
</script>
